/**
 * The website's Schedule Service form lives at /book and /book/card/<key> (pages/PublicBooking.js). App.js renders it
 * on its own, outside the sign-in tree, and index.js skips the push service worker there: a website visitor gets the
 * form and nothing else. (Mirrored by the /book location in nginx.conf, which lets poseidonmarine.com frame it.)
 */
export const isPublicBookingPath = (path) => /^\/book(\/|$)/.test(String(path || ""));

/**
 * The customer's link to an order — /o/<key> (pages/PublicOrder.js): the estimate to approve, the invoice to pay, a job
 * update. Rendered on its own too (App.js), without the push service worker (index.js): a customer, not a team member.
 */
export const isPublicOrderPath = (path) => /^\/o\/[A-Za-z0-9_-]+\/?$/.test(String(path || ""));

/**
 * The website chat window — /chat (pages/PublicChat.js), framed by the chat bubble on poseidonmarine.com
 * (public/chat-widget.js). On its own like the booking form (App.js), without the push service worker (index.js).
 * (Mirrored by the /chat location in nginx.conf, which lets poseidonmarine.com frame it.)
 */
export const isPublicChatPath = (path) => /^\/chat\/?$/.test(String(path || ""));

/**
 * NS Follow-Up's finish link — /f/<code> (pages/PublicNsFinish.js): the short link in every NS text and email. On its
 * own too (App.js), without the push service worker (index.js): a customer, not a team member.
 */
export const isPublicFinishPath = (path) => /^\/f\/[A-Za-z0-9]{8}\/?$/.test(String(path || ""));
